// extracted by mini-css-extract-plugin
export default {"root":"_3_PybuVi","toggle":"_2JmwZPMj","label":"_1kE2WuSs","menu":"_3n-DnLHq","visible":"_3MYnwVQ1"};